import React from 'react'
import { BadgeProps } from './types'
import './index.scss'
import { Icon } from '@petz/ds-icon'

export const Badge: React.FC<BadgeProps> = ({
  text,
  iconName,
  iconVariant,
  role = 'badge',
  brand = 'ptz',
  color = 'primary-brand',
  variant = 'solid',
  size = 'sm',
  iconAlign,
  iconNameLeft,
  iconNameRight,
}) => {
  const sizeClass = `${brand}-badge-${size}`
  const iconAlignClass = iconAlign ? `${brand}-badge-${iconAlign}` : ''

  const classBadge = `${brand}-badge
  ${brand}-badge-${color}-${variant}
  ${sizeClass}
  ${iconAlignClass}`

  const renderLeftIcon = () =>
    (iconNameLeft || (iconAlign === 'left' && iconName)) &&
    (size === 'md' || size === 'lg') && (
      <Icon className={`${brand}-badge-icon ${brand}-badge-icon-left`} name={iconNameLeft ?? iconName ?? 'home'} variant={iconVariant ?? 'line'} size="md" />
    )

  const renderRightIcon = () =>
    (iconNameRight || (iconAlign === 'right' && iconName)) &&
    (size === 'md' || size === 'lg') && (
      <Icon className={`${brand}-badge-icon ${brand}-badge-icon-right`} name={iconNameRight ?? iconName ?? 'home'} variant={iconVariant ?? 'line'} size="md" />
    )

  const renderCentralIcon = () =>
    iconName && !text && <Icon className={`${brand}-badge-icon ${brand}-badge-icon-center`} name={iconName} variant={iconVariant ?? 'line'} size="xs" />

  return (
    <div className="ptz-badge-container">
      <div className={classBadge}>
        {!text && renderCentralIcon()}
        {text && (
          <>
            {renderLeftIcon()}
            <span role={role} className={`${brand}-badge-span`}>
              {text}
            </span>
            {renderRightIcon()}
          </>
        )}
      </div>
    </div>
  )
}
